import React from 'react'
import { propTypes } from '../../helpers'

const VisualizationPdf = ({ visualization }) => {
  return (
    <object
      role='document'
      name={visualization.name}
      title={visualization.name}
      type={visualization.contentType}
      data={URL.createObjectURL(visualization.content)}
    >
      <p>
        The preview is not available for this file type. To view the document,
        download and open.
      </p>
    </object>
  )
}

VisualizationPdf.propTypes = {
  visualization: propTypes.visualizationPropType.isRequired
}

export { VisualizationPdf }
